<template>
    <div class="col-lg-12">
        <h3 class="text-uppercase text-center">Upload Your Documents Below</h3>
        <hr>
        <h4 class="heading text-muted mb-4">
            <!-- Upload Files &nbsp;&nbsp;&nbsp;&nbsp; -->
            <span class="text-danger">
                <i class="fa fa-info-circle"></i> Only PDF Files (Less than 300KB) are supported
            </span>            
        </h4>

        <div class="col-lg-12" v-if="isLoadingBlade">
            <div class="d-flex justify-content-center">
                <img :src="loadingBladeUrl" />
            </div>
        </div>

        <div class="col-lg-12" v-if="! isLoadingBlade">
            <!-- import User Document File template here -->
            <DocumentFile 
                :items="items"
                :showDocuments="showDocuments"
                :showErrorStatus="showErrorStatus"
                :errorMsg="errorMsg"
                :loadApplicantInfo="loadApplicantInfo"
                :lock="lock"
            />
        </div>

        <hr class="my-4" v-if="! isLoadingBlade"/>

        <div class="col-lg-12" v-if="! isLoadingBlade">
            <base-button 
                type="danger" 
                @click="showPreviousPage()"
            >
                <i class="fa fa-arrow-left"></i> 
                Previous
            </base-button>
            <div class="right" v-if="hasCompleteDocuments">
                <base-button 
                    type="success" 
                    @click="showNextPage()"
                >                    
                    Continue 
                    <i class="fa fa-arrow-right"></i> 
                </base-button>
            </div>            
        </div>
    </div>
    
</template>

<script>
    import { mapGetters } from 'vuex';
    import DocumentFile from './DocumentFile.vue';

    export default {
        components: {
            DocumentFile
        },
        name: 'Documents',
        props: ['displayPhoto', 'displaySummary', 'documents', 'application', 'loadApplicantInfo', 'lock'],
        data() {
            return {
                items: {},
                showDocuments: true,
                showErrorStatus: false,
                isLoadingBlade: false,
                errorMsg: null
            }
        },
        computed: {
            ...mapGetters(['loadingBladeUrl']),
            hasCompleteDocuments() {// check if all documents has been uploaded
                let status = [];
                for(let document of this.documents) {
                    status.push(document.hasFile);
                }
                let checker = arr => arr.every(v => v === true);
                return checker(status);
            }
        },
        methods: {
            setData() {
                this.items = {
                    documents: this.documents,
                    id: this.application.id
                };
            },
            showPreviousPage() {// go to next page
                return this.displayPhoto(true);
            },
            showNextPage() {// go to next page
                return this.displaySummary(true);
            }
        },
        mounted() {
            this.setData();
        }
    }
</script>

<style>

</style>
